import { Component, computed, input, model } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-toggle',
  styleUrl: './toggle.css',
  templateUrl: './toggle.html',
})
export class Toggle {
  public readonly colorClass = input('has-checked:bg-neutral-600 outline-neutral-600');
  public readonly darkColorClass = input(
    'dark:has-checked:bg-neutral-500 dark:outline-neutral-500',
  );

  public readonly checked = model(false);

  protected readonly class = computed(() => {
    return `group relative inline-flex w-11 shrink-0 cursor-pointer rounded-full bg-gray-200 p-0.5 ring-1 ring-inset ring-white/20 outline-offset-2 transition-colors duration-200 ease-in-out ${this.colorClass()} has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 ${this.darkColorClass()}`;
  });

  public toggleSelection(e: Event): void {
    e.stopPropagation();
    e.stopImmediatePropagation();
    this.checked.set(!this.checked());
  }
}
